function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import { css, StyleSheet } from "../../styles/theme";
import { H2 } from "./Typography";

var FadeInUp =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FadeInUp, _React$Component);

  function FadeInUp(props) {
    var _this;

    _classCallCheck(this, FadeInUp);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FadeInUp).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "refFadeInUp", void 0);

    _defineProperty(_assertThisInitialized(_this), "styles", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", {
      enableFadeInUp: false
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      window.addEventListener('scroll', _this.triggerOnScroll);

      _this.triggerOnScroll();
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      window.removeEventListener('scroll', _this.triggerOnScroll);
    });

    _defineProperty(_assertThisInitialized(_this), "triggerOnScroll", function () {
      if (!_this.state.enableFadeInUp && _this.isComponentViewable()) {
        _this.setState(function () {
          return {
            enableFadeInUp: true
          };
        }, function () {
          if (_this.props.onAnimationComplete) {
            _this.props.onAnimationComplete(true);
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isComponentViewable", function () {
      if (!_this.refFadeInUp) {
        return false;
      }

      var _this$refFadeInUp$get = _this.refFadeInUp.getBoundingClientRect(),
          height = _this$refFadeInUp$get.height,
          top = _this$refFadeInUp$get.top;

      var windowHeight = window.innerHeight;
      var visibleContainerOffset = windowHeight - top;
      return visibleContainerOffset / height >= _this.props.triggerRatio;
    });

    var fadeInUpKeyframes = {
      from: {
        transform: "translate3d(0, ".concat(props.startPosition, ", 0)")
      },
      to: {
        transform: 'translate3d(0, 0, 0)',
        opacity: 1
      }
    };
    var initialOpacity = typeof window !== 'undefined' ? 0 : 1;
    _this.styles = StyleSheet.create({
      FadeInUp: {
        opacity: initialOpacity
      },
      animateFadeIn: {
        animationName: [fadeInUpKeyframes],
        animationDuration: "".concat(props.delay),
        animationFillMode: 'both'
      }
    });
    return _this;
  }

  _createClass(FadeInUp, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = this.props.children;
      var enableFadeInUp = typeof window !== 'undefined' && this.state.enableFadeInUp;
      return React.createElement("div", _extends({
        ref: function ref(el) {
          _this2.refFadeInUp = el;
        }
      }, css(this.styles.FadeInUp, enableFadeInUp && this.styles.animateFadeIn)), children);
    }
  }]);

  return FadeInUp;
}(React.Component);

_defineProperty(FadeInUp, "defaultProps", {
  startPosition: '25px',
  delay: '1s',
  triggerRatio: 0.25
});

export default FadeInUp;